<mat-accordion class="accordion">
  @for (parentNode of dataSource; track $index) {
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        {{ parentNode.name }}
      </mat-expansion-panel-header>

      <mat-tree [dataSource]="parentNode.dataSource" [treeControl]="treeControl">
        <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
          @if (node.level === 2) {
            <ul>
              <li>{{ node.name }}</li>
            </ul>
          }
          @if (node.level !== 2) {
            {{ node.name }}
          }
        </mat-tree-node>

        <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding>
          <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.name">
            <mat-icon>
              {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
            </mat-icon>
          </button>
          {{ node.name }}
        </mat-tree-node>
      </mat-tree>
    </mat-expansion-panel>
  }
</mat-accordion>
